<template>
  <card>
    <b-spinner v-if="loading" variant="primary" />
    <div v-else>
      <h6 class="mb-5">Comissões</h6>
      <h5 class="text-dark">
        -
      </h5>
    </div>
  </card>
</template>

<script>
import { removeMask } from "@/functions/helpers";

export default {
  props: {
    product_id: {
      type: Number,
      default: null
    },
    refresh: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      total: ""
    };
  },
  computed: {
    totalInNumber() {
      return Number(removeMask(this.total));
    }
  },
  watch: {
    refresh(val) {
      if (val) {
        this.request();
      }
    },
    product_id(id) {
      this.request(id);
    }
  },
  mounted() {
    // return this.request();
  },
  methods: {
    request(id = null) {
      // let param = "";
      // if (id !== null) {
      //   param = `product_id=${id}`;
      // }
      // window.axios
      //   .get(`/sales/total?${param}`)
      //   .then(response => {
      //     this.total = "R$ " + formatMoney(response.data.amount__sum);
      //   })
      //   .catch(() => {
      //     this.total = "Erro!";
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
    }
  }
};
</script>
